import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeStyle as _normalizeStyle, mergeProps as _mergeProps, resolveDynamicComponent as _resolveDynamicComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/newPhone/custom.svg'


const _withScopeId = n => (_pushScopeId("data-v-8624e40a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mod_wrap mod_set_wrap" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mod_c_title" }, "自定义菜单", -1))
const _hoisted_3 = {
  key: 1,
  class: "custom_menu mod_c_ltbody"
}
const _hoisted_4 = { class: "custom_container" }
const _hoisted_5 = { class: "custom_view" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "custom_bg",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_7 = { class: "custom_view_tbody" }
const _hoisted_8 = { class: "cv_title_tbody" }
const _hoisted_9 = { class: "cv_title" }
const _hoisted_10 = { class: "cv_banner" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "cv_menu" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "cv_menu_item_txt" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { class: "cv_imgmsg_tbody" }
const _hoisted_19 = { class: "cvit_username" }
const _hoisted_20 = { class: "cvit_msg" }
const _hoisted_21 = ["src"]
const _hoisted_22 = { key: 2 }
const _hoisted_23 = { class: "cv_content_goods" }
const _hoisted_24 = { class: "goods_item_img" }
const _hoisted_25 = ["src"]
const _hoisted_26 = { class: "goods_item_content" }
const _hoisted_27 = { class: "goods_item_title title_eli" }
const _hoisted_28 = { class: "goods_item_title" }
const _hoisted_29 = { class: "goods_item_desc_price" }
const _hoisted_30 = { class: "goods_item_desc_price" }
const _hoisted_31 = {
  key: 3,
  class: "cv_img_list"
}
const _hoisted_32 = ["src"]
const _hoisted_33 = {
  key: 4,
  class: "cv_video_list"
}
const _hoisted_34 = { class: "cvvl_item_cover" }
const _hoisted_35 = ["src"]
const _hoisted_36 = { class: "mod_ellip" }
const _hoisted_37 = { class: "custom_editor" }
const _hoisted_38 = { class: "custom_editor_tabs_wrap" }
const _hoisted_39 = ["onClick"]
const _hoisted_40 = { class: "custom_editor_tabpane" }
const _hoisted_41 = { class: "cetp_input_wrap" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "video_radio_title" }, "菜单名称：", -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "video_radio_title" }, "菜单分类：", -1))
const _hoisted_44 = { class: "cetp_input_wrap_tbody" }
const _hoisted_45 = { class: "cetp_input_wrap_foot" }

import CDelModal from '@/components/CDelModal.vue';
import { RootModal } from '@/components/CDelModal.vue';
import { computed, defineAsyncComponent, inject, reactive, ref, unref, watch } from 'vue';
import { Alert, message } from 'ant-design-vue';
import { customMenuView } from '@/assets';
import { CloseOutlined, EllipsisOutlined, PlusCircleOutlined } from '@ant-design/icons-vue';
import { VueDraggableNext } from 'vue-draggable-next';
import { LiveInfo } from '@/store/modules/live/types';
import type { CustomItem, CustomMenu, ImgTextRelease, IOption, MenuContentType, TxtContent, GoodItem, VideoItem } from './type';
import { OriginData } from './type';
import http from '@/api';
import { useRoute } from 'vue-router';
import { useDebounce } from '@/hooks/useDebounce';
import { dragDrop } from '@/utils/format/dragDrop';
import CLoading from '@/components/CLoading.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomizeMenu',
  setup(__props) {

const draggable = VueDraggableNext;
const dragOptions = ref({
  animation: 200,
  group: 'description',
  disabled: false,
  ghostClass: 'ghost',
});

// const aModal = Modal;
const Crumb = defineAsyncComponent(() => import('@/components/Crumb.vue'));
const aAlert = Alert;
const alert = '添加在线成员、图文内容、图文发布、跳转链接、商品及视频列表,支持拖拽对菜单和列表内容进行排序。';

const options: IOption[] = reactive([
  { value: '1', label: '聊天互动', disabled: true },
  { value: '2', label: '图文内容' },
  { value: '3', label: '图文发布' },
  { value: '8', label: '图片内容' },
  { value: '4', label: '商品列表' },
  { value: '5', label: '视频列表' },
  { value: '6', label: '跳转链接' },
  { value: '7', label: '在线观众', disabled: false },
  { value: '9', label: '外部页面' },
  { value: '10', label: '文档内容' },
  { value: '11', label: '问卷调查' },
  { value: '13', label: '视频打点', disabled: false },
  { value: '14', label: '分享榜单' },
]);

// const activePage = ref();
const Chat = defineAsyncComponent(() => import('./components/Chat.vue'));
const ImageText = defineAsyncComponent(() => import('./components/ImageText.vue'));
const Word = defineAsyncComponent(() => import('./components/Word.vue'));
const MemberList = defineAsyncComponent(() => import('./components/MemberList.vue'));
const Link = defineAsyncComponent(() => import('./components/Link.vue'));
const Questionnaire = defineAsyncComponent(() => import('./components/Questionnaire.vue'));
const ImageTextRelease = defineAsyncComponent(() => import('./components/ImageTextRelease.vue'));
const GoodList = defineAsyncComponent(() => import('./components/GoodList.vue'));
const Image = defineAsyncComponent(() => import('./components/Image.vue'));
const ExternalPage = defineAsyncComponent(() => import('./components/ExternalPage.vue'));
const Video = defineAsyncComponent(() => import('./components/VideoList.vue'));
const VideoDot = defineAsyncComponent(() => import('./components/VideoDot.vue'));
const ShareList = defineAsyncComponent(()=>import('./components/ShareList.vue'))

const components = [
  null,
  Chat,
  ImageText,
  ImageTextRelease,
  GoodList,
  Video,
  Link,
  MemberList,
  Image,
  ExternalPage,
  Word,
  Questionnaire,
  null,
  VideoDot,
  ShareList,
  //   ExternalPage,
  //   Video,
  //   ImageTextRelease,
];

// 直播信息
const route = useRoute();
const studioId = route.params.studioId as string;
const liveInfo = computed(() => unref(inject('liveInfo') as LiveInfo));
const menuForm = ref<CustomMenu>({
  id: liveInfo.value.id as number,
  display_chat: 0,
  display_member: 0,
  studio_id: 0,
  menu: [
    {
      name: '聊天互动',
      type_id: '1',
      index: 0,
      isActive: true,
      datas: { content: '' },
    },
  ],
  origin_datas: [
    {
      type_id: '1',
      datas: { content: '' },
    },
  ],
});

//选择项 vmodel
const select = ref<IOption>({
  label: '',
  value: '',
});

const activedTabId = ref(0); // 当前选中 index

// 切换选中项
const onChangeMenuType = (typeId: string) => {
  const selectKey = options.findIndex((e) => e.value === typeId);
  return options[selectKey];
};

// 聊天互动不能删除
const isChat = computed(() => {
  return menuForm.value.menu[activedTabId.value].type_id === '1';
});

const showLoading = ref(false);
// 初始化菜单
const init = async () => {
  try {
    showLoading.value = true;
    const res = await http.live.getMenu({ params: { studio_id: studioId } });
    menuForm.value = res.data.data;
    showLoading.value = false;
    // 处理菜单的结构变对象问题
    !Array.isArray(unref(menuForm.value.menu)) &&
      (menuForm.value.menu = Object.keys(menuForm.value.menu).map((item) => menuForm.value.menu[item]));
    !Array.isArray(menuForm.value.origin_datas) &&
      (menuForm.value.origin_datas = Object.keys(menuForm.value.origin_datas).map((item) => menuForm.value.origin_datas[item]));
    // 处理菜单的结构变对象问题 -end

    if (menuForm.value.menu.length > 0) {
      menuForm.value.menu = menuForm.value.menu.map((e, index) => {
        e.isActive = index === 0 ? (e.isActive = true) : false;
        return e;
      });
    }
    select.value = onChangeMenuType(menuForm.value.menu[activedTabId.value].type_id);
    lineUser();
  } catch (err) {
    const msg = err?.data?.error || '数据异常请联系管理员！';
    message.error(msg);
    showLoading.value = false;
  }
};
init();

const liveinfoRefObj = inject('liveInfo') as LiveInfo;
watch(
  liveinfoRefObj,
  (newVal) => {
    if (newVal.mode === 4) {
      Boolean(options.find((item) => item.value === '12')) === false && options.push({ value: '12', label: '频道列表' });
    }
  },
  {
    immediate: true,
  }
);

// 切换选中的 Tab 项
const onChangeTab = (arr: CustomItem[], newIndex: number) => {
  return arr.map((e, index) => {
    e.isActive = index === newIndex ? true : false;
    e.index = index;
    return e;
  });
};

// 保存的请求
const onSaveMenu = useDebounce(() => {
  const data = menuForm.value;
  data.menu.forEach((item, index) => {
    if (!data.origin_datas[index]) {
      data.origin_datas[index] = {
        type_id: item.type_id,
        datas: item.datas,
      };
    } else {
      data.origin_datas[index].type_id = item.type_id;
      data.origin_datas[index].datas = item.datas;
    }
  });
  const formData = {
    menu: data.menu,
    origin_datas: data.origin_datas,
    studio_id: data.studio_id,
  };
  http.live
    .saveMenu(formData)
    .then((res) => {
      message.destroy();
      message.success(res.data.message);
    })
    .catch((res) => {
      message.destroy();
      message.error(res.data.error);
    });
});

// 选中点击
const onSelectCmt = (item: CustomItem, index: number) => {
  activedTabId.value = index;
  menuForm.value.menu = onChangeTab(menuForm.value.menu, index);
  select.value = onChangeMenuType(item.type_id);
};

// 拖动回调
const moveEnd = (obj: any) => {
  const { menu } = menuForm.value;
  const newIndex = obj.moved.newIndex;
  onSelectCmt(menu[newIndex], newIndex);
  // menuForm.value.menu = onChangeTab(menu, newIndex);
  // 拖动后需要同时修改备份的数据
  const arr: OriginData[] = [];
  menuForm.value.origin_datas;
  menuForm.value.menu.forEach((e?: any) => {
    arr.push(new OriginData(e));
  });
  menuForm.value.origin_datas = arr;
  onSaveMenu();
};

// 添加 Tab
const onAddTab = () => {
  const { menu, origin_datas } = menuForm.value;
  menu.push({
    index: menu.length,
    name: '图文内容',
    type_id: '2',
    isActive: true,
    datas: {
      content: '',
    },
  });
  origin_datas.push({
    type_id: '2',
    datas: {
      content: '',
    },
  });
  onSelectCmt(menu[menu.length - 1], menu.length - 1);
  onSaveMenu();
};

// 删除
const delModal = reactive<RootModal>({
  title: '提示',
  visible: false,
  loading: false,
});
const openDelModal = () => {
  delModal.visible = !delModal.visible;
};
const onRemoveTab = () => {
  if (select.value.value === '7') options[7].disabled = false;
  if (select.value.value === '13') options[11].disabled = false;
  const { menu, origin_datas } = menuForm.value;
  const delId = activedTabId.value;
  if (activedTabId.value > 0) {
    activedTabId.value -= 1;
  } else {
    activedTabId.value = 0;
  }
  menu.splice(delId, 1);
  origin_datas.splice(delId, 1);
  onSelectCmt(menu[activedTabId.value], activedTabId.value);
  onSaveMenu();
  openDelModal();
  getMemberSwitch();
};
const getMemberSwitch = () => {
  let data = {
    status: 0,
    studio_id: studioId,
  };
  http.liveInformation
    .getMemberSwitch(data)
    .then((res) => {
      if (res.data.code == 200) {
        message.destroy();
        message.success(res.data.message);
      }
    })
    .catch((res) => {
      message.destroy();
      message.error(res.data.error);
    });
};

// 组件标题
const onKeywordTitle = () => {
  const str = menuForm.value.menu[activedTabId.value].name;
  // eslint-disable-next-line no-control-regex
  let cArr = str.match(/[^\x00-\xff]/gi);
  let eArr = str.match(/[a-zA-Z]/gi);
  let num = str.match(/[0-9]/gi);
  if (eArr == null ? 0 : eArr.length > 15) {
    message.destroy();
    message.error('英文不能大于15个字符！');
    if (eArr == null) {
      menuForm.value.menu[activedTabId.value].name = str.substr(0, 8);
    } else {
      menuForm.value.menu[activedTabId.value].name = str.substr(0, 15);
    }
  }
  if (cArr == null ? 0 : cArr.length > 5) {
    message.destroy();
    message.error('菜单名称中文不能大于5个字符！');
    if (cArr == null) {
      menuForm.value.menu[activedTabId.value].name = str.substr(0, 8);
    } else {
      menuForm.value.menu[activedTabId.value].name = str.substring(0, 5);
    }
  }
  if (num && num.length > 5) {
    message.destroy();
    message.error('菜单名称不能大于5个字符！');
    menuForm.value.menu[activedTabId.value].name = str.substr(0, 5);
  }
  if (num && cArr && num.length + cArr.length > 5) {
    message.destroy();
    message.error('菜单名称中文不能大于5个字符！');
    menuForm.value.menu[activedTabId.value].name = str.substr(0, 5);
  }
  if (num && eArr && num.length + eArr.length > 15) {
    message.destroy();
    message.error('菜单名称英文不能大于15个字符！！');
    menuForm.value.menu[activedTabId.value].name = str.substr(0, 15);
  }
  if (eArr && cArr && eArr.length + cArr.length > 5) {
    message.destroy();
    message.error('菜单名称不能大于5个字符！！');
    menuForm.value.menu[activedTabId.value].name = str.substr(0, 5);
  }
  if (eArr && cArr && num && eArr.length + cArr.length + num.length > 5) {
    message.destroy();
    message.error('菜单名称不能大于5个字符！！');
    menuForm.value.menu[activedTabId.value].name = str.substr(0, 5);
  }
};

const getBaseData = (typeId: string): MenuContentType => {
  switch (true) {
    case typeId === '6':
      return {
        content: '',
        content_url: 'http://',
      };
    case typeId === '2':
      return {
        content: '',
      };
    case typeId === '3':
      return {
        content: [],
        host: '',
      };
    case typeId === '9':
      return {
        menu_type: true,
        expand_type: '',
        popup: '',
        expand_url: '',
        expand_name: '',
        height: '',
        content_url: '',
        callback_url: '',
      };
    default:
      return [];
  }
};

// 菜单分类切换
const onHandleChange = () => {
  const menuItem = menuForm.value.menu[activedTabId.value];
  const originDataItem = menuForm.value.origin_datas[activedTabId.value];
  if (select.value.value === originDataItem.type_id) {
    menuItem.datas = originDataItem.datas;
  } else {
    menuItem.datas = getBaseData(select.value.value);
  }
  menuItem.name = select.value.label;
  menuItem.type_id = select.value.value;
  lineUser();
};

const lineUser = () => {
  if (menuForm.value.menu.length > 0) {
    menuForm.value.menu.forEach((e) => {
      if (e.type_id === '7') options[7].disabled = true;
      if (e.type_id === '13') options[11].disabled = true;
    });
  }
};

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_select = _resolveComponent("a-select")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(Crumb)),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      (showLoading.value)
        ? (_openBlock(), _createBlock(CLoading, { key: 0 }))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", null, [
              _createVNode(_unref(aAlert), {
                class: "custom_menu_alert",
                message: alert,
                type: "warning",
                "show-icon": ""
              })
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_unref(CloseOutlined)),
                    _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(liveInfo).title), 1),
                    _createVNode(_unref(EllipsisOutlined))
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _withDirectives(_createElementVNode("img", {
                      class: "cv_banner_img",
                      src: _unref(liveInfo).image_player_cover_url,
                      alt: ""
                    }, null, 8, _hoisted_11), [
                      [_vShow, _unref(liveInfo).image_player_cover_url]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuForm.value.menu, (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: _normalizeClass([item.isActive ? 'actived' : '', "cv_menu_item"]),
                        onClick: ($event: any) => (onSelectCmt(item, index))
                      }, [
                        _createElementVNode("span", _hoisted_14, _toDisplayString(item.name), 1)
                      ], 10, _hoisted_13))
                    }), 128))
                  ]),
                  _createElementVNode("div", {
                    class: "cv_content",
                    style: _normalizeStyle({ background: `${menuForm.value.menu[activedTabId.value].type_id !== '1' ? '#fff' : ''}` })
                  }, [
                    (menuForm.value.menu[activedTabId.value].type_id === '2' || menuForm.value.menu[activedTabId.value].type_id === '6')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                          _createElementVNode("div", {
                            innerHTML: (menuForm.value.menu[activedTabId.value].datas  as TxtContent).content
                          }, null, 8, _hoisted_16)
                        ]))
                      : _createCommentVNode("", true),
                    (menuForm.value.menu[activedTabId.value].type_id === '3')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((menuForm.value.menu[activedTabId.value].datas  as ImgTextRelease).content, (item) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: item.created_at,
                              class: "cv_imgmsg_wrap"
                            }, [
                              _createTextVNode(_toDisplayString(item.created_at) + " ", 1),
                              _createElementVNode("div", _hoisted_18, [
                                _createElementVNode("p", _hoisted_19, _toDisplayString((menuForm.value.menu[activedTabId.value].datas as ImgTextRelease).host), 1),
                                _createElementVNode("p", _hoisted_20, _toDisplayString(item.content), 1),
                                (item.img)
                                  ? (_openBlock(), _createElementBlock("img", {
                                      key: 0,
                                      class: "cvit_img",
                                      src: item.img,
                                      alt: ""
                                    }, null, 8, _hoisted_21))
                                  : _createCommentVNode("", true)
                              ])
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    (menuForm.value.menu[activedTabId.value].type_id === '4' && (menuForm.value.menu[activedTabId.value].datas as GoodItem[]).length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                          _createElementVNode("div", _hoisted_23, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((menuForm.value.menu[activedTabId.value].datas as GoodItem[]), (good, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "cv_content_goods_item",
                                key: index
                              }, [
                                _createElementVNode("div", _hoisted_24, [
                                  (good.img)
                                    ? (_openBlock(), _createElementBlock("img", {
                                        key: 0,
                                        class: "img",
                                        src: good.img,
                                        alt: ""
                                      }, null, 8, _hoisted_25))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", _hoisted_26, [
                                  _createElementVNode("p", _hoisted_27, _toDisplayString(good.title), 1),
                                  _createElementVNode("p", _hoisted_28, [
                                    _createElementVNode("span", _hoisted_29, "¥" + _toDisplayString(good.price), 1),
                                    _createElementVNode("span", _hoisted_30, _toDisplayString(good.origin_price), 1)
                                  ])
                                ]),
                                _createElementVNode("div", null, [
                                  _createVNode(_component_a_button, {
                                    size: "large",
                                    class: "gifbtn_buy",
                                    type: "link"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(good.btn_name), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ])
                              ]))
                            }), 128))
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (menuForm.value.menu[activedTabId.value].type_id === '8' && (menuForm.value.menu[activedTabId.value].datas as string[]).length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((menuForm.value.menu[activedTabId.value].datas as string[]), (item, index) => {
                            return (_openBlock(), _createElementBlock("img", {
                              key: index,
                              src: item,
                              alt: ""
                            }, null, 8, _hoisted_32))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    (menuForm.value.menu[activedTabId.value].type_id === '5' && (menuForm.value.menu[activedTabId.value].datas  as VideoItem[]).length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((menuForm.value.menu[activedTabId.value].datas as VideoItem[]), (item, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: index,
                              class: "cvvl_item"
                            }, [
                              _createElementVNode("div", _hoisted_34, [
                                _createElementVNode("img", {
                                  src: item.cover_url,
                                  alt: ""
                                }, null, 8, _hoisted_35)
                              ]),
                              _createElementVNode("p", _hoisted_36, _toDisplayString(item.title), 1)
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ], 4)
                ])
              ]),
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("div", _hoisted_38, [
                  _createVNode(_unref(draggable), _mergeProps({
                    class: "custom_editor_tabs list-group",
                    list: menuForm.value.menu
                  }, dragOptions.value, {
                    onChange: moveEnd,
                    onDrop: _unref(dragDrop)
                  }), {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuForm.value.menu, (item, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "list-group-item cet_item",
                          key: index,
                          onClick: ($event: any) => (onSelectCmt(item, index))
                        }, [
                          _createVNode(_component_a_button, {
                            type: "link",
                            size: "large",
                            class: _normalizeClass(["list-group-item-btn", item.isActive === true ? 'actived' : ''])
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.name), 1)
                            ]),
                            _: 2
                          }, 1032, ["class"])
                        ], 8, _hoisted_39))
                      }), 128))
                    ]),
                    _: 1
                  }, 16, ["list", "onDrop"]),
                  _createVNode(_component_a_button, {
                    type: "link",
                    size: "large",
                    class: "cet_btn",
                    disabled: menuForm.value.menu.length === 5,
                    onClick: onAddTab
                  }, {
                    icon: _withCtx(() => [
                      _createVNode(_unref(PlusCircleOutlined), { class: "modal_place_salist_btn" })
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ]),
                _createElementVNode("div", _hoisted_40, [
                  _createElementVNode("div", _hoisted_41, [
                    _hoisted_42,
                    _createVNode(_component_a_input, {
                      class: "cetp_input_wrap_input",
                      value: menuForm.value.menu[activedTabId.value].name,
                      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((menuForm.value.menu[activedTabId.value].name) = $event)),
                      onChange: onKeywordTitle
                    }, null, 8, ["value"]),
                    _hoisted_43,
                    _createVNode(_component_a_select, {
                      class: "cetp_input_wrap_input",
                      value: select.value,
                      "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((select).value = $event)),
                      options: options,
                      disabled: _unref(isChat),
                      onChange: _cache[2] || (_cache[2] = ($event: any) => (onHandleChange())),
                      "label-in-value": ""
                    }, null, 8, ["value", "options", "disabled"])
                  ]),
                  _createElementVNode("div", _hoisted_44, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuForm.value.menu, (item, index) => {
                      return (_openBlock(), _createElementBlock("div", { key: index }, [
                        (item.isActive)
                          ? (_openBlock(), _createBlock(_resolveDynamicComponent(components[parseInt(item.type_id)]), {
                              key: 0,
                              modelValue: item.datas,
                              "onUpdate:modelValue": ($event: any) => ((item.datas) = $event),
                              index: item.index,
                              "onClick:save": _unref(onSaveMenu)
                            }, null, 40, ["modelValue", "onUpdate:modelValue", "index", "onClick:save"]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ]),
                  _createElementVNode("div", _hoisted_45, [
                    _createVNode(_component_a_button, {
                      class: "mod_modal_btn",
                      disabled: _unref(isChat),
                      onClick: openDelModal
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("删除")
                      ]),
                      _: 1
                    }, 8, ["disabled"]),
                    _createVNode(_component_a_button, {
                      class: "mod_modal_btn mod_type_primary2",
                      onClick: _unref(onSaveMenu),
                      type: "primary"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("保存")
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ])
                ])
              ]),
              _createVNode(CDelModal, {
                visible: delModal.visible,
                centered: "",
                close: openDelModal,
                ok: onRemoveTab
              }, {
                title: _withCtx(() => [
                  _createTextVNode("此操作将删除该菜单，是否继续？")
                ]),
                _: 1
              }, 8, ["visible"])
            ])
          ]))
    ])
  ], 64))
}
}

})